<template>
  <div v-if="result" class="product-slider">
    <!--Thumbs slider-->
    <div>
      <DefSliderWrapper v-if="screenWidth >= 768" class="vertical">
        <Swiper
          :modules="[Thumbs, Navigation]"
          :navigation="{
            prevEl: prev,
            nextEl: next,
          }"
          v-bind="verticalSettings"
          class="product-vertical"
          @swiper="setThumbsSwiper"
        >
          <SwiperSlide v-for="(item, i) in result" :key="i">
            <img :src="item.preview" :alt="item.alt" class="product-vertical__image" />
          </SwiperSlide>

          <SwiperSlide v-if="isExistVideoPreview">
            <img
              :src="videoPreview.src"
              :alt="videoPreview.alt"
              class="product-vertical__image"
              @click="isVideoShowed = true"
            />
          </SwiperSlide>

          <SwiperSlide v-if="isExistFbxPreview">
            <img :src="fbxPreview.src" :alt="fbxPreview.alt" class="product-vertical__image" />
          </SwiperSlide>
        </Swiper>
        <div ref="prev" class="swiper-button-prev"></div>
        <div ref="next" class="swiper-button-next"></div>
      </DefSliderWrapper>
    </div>
    <DefSliderWrapper>
      <!-- Main slider -->
      <Swiper
        :thumbs="{ swiper: thumbsSwiper }"
        :modules="mainSliderModules"
        v-bind="horizontalSettings"
        class="product-horizontal"
        @slideChange="handlerSlideChange"
      >
        <SwiperSlide v-for="(item, i) in result" :key="i">
          <DefZoom v-if="screenWidth >= 992" :src="item.src" :alt="item.alt" />
          <img v-else :src="item.src" :alt="item.alt" class="product-horizontal__image" />
        </SwiperSlide>

        <SwiperSlide v-if="isExistVideoPreview">
          <div class="product-horizontal__videoWrapper">
            <!--                        <svg class="product-horizontal__play"-->
            <!--                             v-if="!isVideoShowed && screenWidth < 768"-->
            <!--                             @click="isVideoShowed = true"-->
            <!--                        >-->
            <!--                            <use xlink:href="#svg-play"></use>-->
            <!--                        </svg>-->
            <!--                        <DefImg-->
            <!--                                v-if="!isVideoShowed"-->
            <!--                                :result="videoPreview"-->
            <!--                                :maxSizeOff="screenWidth < 768"-->
            <!--                                @click="isVideoShowed = true"-->
            <!--                                class="product-horizontal__image"-->
            <!--                        />-->
            <!--              v-if="slideIndex === result.length"-->
            <!--            :play="slideIndex === result.length"-->
            <DefVideo :play="slideIndex === result.length" :result="video" />
            <!--              v-if="slideIndex === result.length"-->
            <!--            <video-->
            <!--              :src="video.src"-->
            <!--              :alt="video.name"-->
            <!--              class="product-horizontal__video"-->
            <!--              autoplay-->
            <!--              loop-->
            <!--              muted-->
            <!--              playsinline-->
            <!--            />-->
          </div>
        </SwiperSlide>

        <SwiperSlide v-if="isExistFbxPreview">
          <img
            :src="fbxPreview.src"
            :alt="fbxPreview.alt"
            class="product-horizontal__image product-horizontal__fbx"
            @click="isOpen3D = true"
          />
        </SwiperSlide>
      </Swiper>
      <GiaPhoto v-if="isGia" />
    </DefSliderWrapper>

    <DefSlideModal v-if="isExistFbx" :active="isOpen3D" @close="isOpen3D = false">
      <template #title>
        {{ productType }}
      </template>
      <div class="modal-3d">
        <DefImg3d />
        <p class="modal-3d__text">
          {{ screenWidth >= 992 ? text3DDesktop : text3DMobile }}
        </p>
      </div>
      <!--            <GetTodayList-->
      <!--                v-if="!currentReserveShop"-->
      <!--                :result="result"-->
      <!--                :messages="messages"-->
      <!--                @reserve="handlerReserve"-->
      <!--            />-->
      <!--            <GetTodayDetail-->
      <!--                v-else-->
      <!--                :result="result"-->
      <!--                :reserveShop="currentReserveShop"-->
      <!--                :messages="messages"-->
      <!--                @close="isOpen3D = false"-->
      <!--            />-->
    </DefSlideModal>
  </div>
</template>

<script setup>
import { defineProps, ref, computed, onMounted } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Thumbs, Navigation, Pagination } from 'swiper/modules';
import { useStore } from '@store';
import DefZoom from '@components/Def/DefZoom/DefZoom.vue';
import GiaPhoto from '@components/Product/GiaPhoto.vue';
import DefImg3d from '@components/Def/DefImg/DefImg3d.vue';
import { screenWidth } from '@use/useDeviceInfo';
import DefSlideModal from '@components/Def/DefSlideModal/DefSlideModal.vue';
import DefVideo from '@components/Def/DefVideo/DefVideo.vue';
import DefSliderWrapper from './DefSliderWrapper';

const store = useStore();

const fbxPreview = computed(() => store.state.product.data.product?.fbxPreview);
const productType = computed(() => store.state.product.data.product?.type);
const isExistFbxPreview = computed(() => store.state.product.data.product?.isExistFbxPreview);
const isExistFbx = computed(() => store.state.product.data.product?.isExistFbx);

const isExistVideoPreview = computed(() => store.state.product.data.product?.isExistVideoPreview);
const videoPreview = computed(() => store.state.product.data.product?.videoPreview);
const video = computed(() => store.state.product.data.product?.video);

const text3DDesktop = computed(() => store.state.product.data.messages?.text3DDesktop);
const text3DMobile = computed(() => store.state.product.data.messages?.text3DMobile);

const isGia = computed(() => store.state.product.data.product?.isGia);

const mainSliderModules = [Pagination, Thumbs, Navigation];

const { result } = defineProps(['result']);
const horizontalSettings = {
  slidesPerView: 1,
  navigation: true,
  breakpoints: {
    768: {
      pagination: {
        enabled: false,
      },
    },
  },
  // on: {
  //     slideChange(e) {
  //         console.log(e);
  //
  //     },
  //     init: function () {
  //         alert(1);
  //         // do something
  //     },
  // }
};

if (result?.length > 1 || isExistFbxPreview) {
  horizontalSettings.pagination = { clickable: true };
}
const prev = ref(null);
const next = ref(null);
const isVideoShowed = ref(false);

const verticalSettings = {
  direction: 'vertical',
  autoHeight: true,
  watchSlidesProgress: true,
  spaceBetween: 8,
  breakpoints: {
    992: {
      slidesPerView: 5,
    },
    768: {
      slidesPerView: 7,
    },
    576: {
      slidesPerView: 3,
    },
    300: {
      slidesPerView: 2,
    },
  },
};

const slideIndex = ref(0);

const handlerSlideChange = ({ activeIndex }) => {
  slideIndex.value = activeIndex;
};

const thumbsSwiper = ref(null);
const setThumbsSwiper = (swiper) => {
  thumbsSwiper.value = swiper;
};

const isOpen3D = ref(false);
</script>

<script>
export default {
  name: 'ProductSlider',
};
</script>
<style lang="scss" scoped>
.product-slider {
  display: grid;
  grid-template-columns: minmax(290px, 1fr);
  @include point-md {
    display: grid;
    grid-template-columns: 32px minmax(0, 1fr);
    grid-column-gap: 8px;
  }
  @include point-lg {
    grid-template-columns: 72px minmax(0, 1fr);
  }
  :deep(.gia-photo) {
    position: absolute;
    bottom: 12px;
    right: 24px;
    max-width: 100px;
    z-index: 1;
    @include point-md {
      bottom: unset;
    }
    @include point-lg {
      bottom: 12px;
      top: unset;
    }
  }
}
.product-vertical {
  //max-height: 632px;
  padding-top: 1px;
  @media (min-width: 576px) {
    height: 112px;
  }
  @include point-md {
    height: 272px;
  }
  @include point-lg {
    height: 392px;
  }
  &__image {
    //max-height: 100%;
    @include point-md {
      max-height: 32px;
    }
    @include point-lg {
      max-height: 72px;
    }
    //max-width: 100%;
    border: 1px solid transparent;
    transition: 0.2s linear border-color;
  }
  :deep(.swiper-slide-thumb-active) {
    .product-vertical__image {
      border-color: #618eaf;
    }
  }
  :deep(.swiper) {
    height: 100%;
  }
  :deep(.swiper-slide) {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
}
.product-horizontal {
  &__image {
    max-width: 100%;
  }
  &__fbx {
    cursor: pointer;
  }
  &__videoWrapper {
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    position: relative;
  }
  &__video {
    width: 100%;
    height: 200px;
    @include point-md {
      height: 250px;
    }
    @include point-xl {
      height: 400px;
    }
  }
  //&__play{
  //    position: absolute;
  //    top: 50%;
  //    left: 50%;
  //    transform: translate(-50%, -50%);
  //    z-index: 1;
  //    width: 32px;
  //    height: 32px;
  //    cursor: pointer;
  //}
  :deep(.def-slider-wrapper .swiper-pagination) {
    margin-top: 16px;
  }
  :deep {
    .zoom {
      display: block;
    }
    .swiper-slide {
      padding: 20px;
      @include point-md {
        padding: 0 40px;
      }
    }
    .swiper-pagination {
      margin-top: 16px;
      @include point-lg {
        margin-top: 24px;
      }
    }
  }
}
.modal-3d {
  &__text {
    font-size: 12px;
    color: #757575;
    text-align: center;
    margin-top: 24px;
    @include point-md {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      margin-top: 0;
      top: 0;
    }
  }
}
</style>
